<script setup>
    import { ClipboardDocumentListIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <ClipboardDocumentListIcon />
</template>
